const SIGNATURE = `__react-kakao-maps-sdk__`;

export { SIGNATURE };
